// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2_AIS","insightsList":"newBusinessInsightsMenu_insightsList__2liei","active":"newBusinessInsightsMenu_active__2_4Xc"};